// extracted by mini-css-extract-plugin
export default {"beautyInsiderForm":"qga-z","errorText":"rga-z"};